<template>
  <!-- 看板 -->
  <div class="report">
    <div class="top_center">
      <div class="top flex">
        <div style="font-size:16px;" class="top_left font_bo flex">
          <div class="cursor" :class="titlestuts == 1 ? 'top_left_list' : ''" @click="tits(1)">订单详情</div>
          <div class="cursor" :class="titlestuts == 2 ? 'top_left_list' : ''" @click="tits(2)">联盟客详情</div>
          <div class="cursor" :class="titlestuts == 3 ? 'top_left_list' : ''" @click="tits(3)">重复订单详情</div>
        </div>
        <div class="top1 flex">
          <div class="top_center1 flex">
            <div class="top_center_one">
              <p class="sz12 co70">国家/地区</p>
              <el-dropdown trigger="click" @visible-change='iconclick(1)'>
                <div class="sz16 scect flex">美国(UTC-5)<i v-if="iconstuts" class="el-icon-caret-right"></i><i v-else
                    class="el-icon-caret-bottom"></i></div>
                <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美国(UTC-5)</div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="top_center_two">
              <p class="sz12 co70">币种</p>
              <el-dropdown trigger="click" @visible-change='iconclick(2)'>
                <div class="sz16 scect flex">美元<i v-if="iconstuts2" class="el-icon-caret-right"></i><i v-else
                    class="el-icon-caret-bottom"></i></div>
                <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美元 </div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="title_top flex">
        <div class="title flex" v-if="titlestuts == 1">
          <div class="title_input">
            <el-input v-model="orderId" placeholder="搜索原始订单号"></el-input>
            <div class="icons">
              <img src="../../assets/img/foll/search.png" alt="">
            </div>
          </div>
          <div class="title_ks">
            <div class="block">
              <el-date-picker prefix-icon="iconoic" v-model="valuescf" type="daterange" range-separator="至"
                start-placeholder="选择开始日期" end-placeholder="选择结束日期" @change="startDa">
              </el-date-picker>
              <img src="@/assets/img/emil/rl.png" alt="" />
            </div>
          </div>
          <div class="title_scslt" v-if="titlestuts != 3">
            <el-select v-model="platformType" clearable placeholder="联盟平台" @clear="delValue" @change="addvalue">
              <el-option v-for="item in hasplist" :key='item.channelType' :label="item.channelTypeValue"
                :value="item.channelTypeValue"></el-option>
            </el-select>
          </div>
        </div>
        <div class="title flex" v-if="titlestuts == 2">
          <div class="title_input">
            <el-input v-model="formdata.affliateInfo" placeholder="搜索联盟客姓名/ID/推广网站"></el-input>
            <div class="icons">
              <img src="../../assets/img/foll/search.png" alt="">
            </div>
          </div>
          <div class="title_ks">
            <div class="block">
              <el-date-picker prefix-icon="iconoic" v-model="values2" type="daterange" range-separator="至"
                start-placeholder="选择开始日期" end-placeholder="选择结束日期" @change="startDatwo">
              </el-date-picker>
              <img src="@/assets/img/emil/rl.png" alt="" />
            </div>
          </div>
          <div class="title_scslt">
            <el-select v-model="formdata.platformType" clearable placeholder="联盟平台" @clear="delValuetwo"
              @change="addvaluetwo">
              <el-option v-for="item in hasplist" :key='item.channelType' :label="item.channelTypeValue"
                :value="item.channelTypeValue"></el-option>
            </el-select>
          </div>
        </div>
        <div class="title flex" v-if="titlestuts == 3">
          <div class="title_input">
            <el-input v-model="formdatatwo.orderId" placeholder="搜索订单号"></el-input>
            <div class="icons">
              <img src="../../assets/img/foll/search.png" alt="">
            </div>
          </div>
          <div class="title_ks">
            <div class="block">
              <el-date-picker prefix-icon="iconoic" v-model="values3" type="daterange" range-separator="至"
                start-placeholder="选择开始日期" end-placeholder="选择结束日期" @change="startDashr">
              </el-date-picker>
              <img src="@/assets/img/emil/rl.png" alt="" />
            </div>
          </div>
        </div>
        <div class="title_qu">
          <div class="title_query ba6e coff center ru5 cursor" @click="searchs1">查询</div>
        </div>
      </div>
      <div class="tablelist tab1 ru5 baff" v-if="titlestuts == 1">
        <el-table key="one" :data="tableData1" style="width: 100%;font-size: 12px; color: #000;"
          :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }" @sort-change="changeTableSort1">

          <el-table-column prop="transactionDate" label="日期" sortable="custom"></el-table-column>
          <el-table-column prop="orderId" label="原始订单号" min-width=""></el-table-column>
          <el-table-column prop="transactionAmount" label="分销金额" sortable="custom" width="">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.transactionAmount).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="totalCommission" label="佣金金额" sortable="custom" width="">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.totalCommission).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="networkCommission" label="平台费用" sortable="custom" width="">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.networkCommission).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="affiliateId" label="联盟客ID" width=""></el-table-column>
          <el-table-column prop="website" show-overflow-tooltip label="联盟客姓名" width="180"></el-table-column>
          <el-table-column prop="affiliateWebsite" show-overflow-tooltip label="推广网站" min-width="180"></el-table-column>
          <el-table-column prop="tags" show-overflow-tooltip label="联盟客类型" min-width=""></el-table-column>
          <el-table-column prop="platformType" label="联盟平台" width="">
          </el-table-column>
        </el-table>
      </div>
      <div class="pages" v-if="tableData1.length && titlestuts == 1">
        <Pagination :pageNo="currentPage" :pageSize="size" :total="total" :continues="4" @getPageNo="getPageNo" />
      </div>
      <div class="tablelist tab2 ru5 baff" v-if="titlestuts == 2">
        <el-table key="two" :data="tableData2" style="width: 100%;font-size: 12px; color: #000;"
          :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }" @sort-change="changeTableSort">
          <el-table-column prop="affiliateid" label="联盟客ID"></el-table-column>
          <el-table-column prop="website" show-overflow-tooltip label="联盟客姓名">
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <div style="color:#000">{{ scope.row.website }}</div>
                <span slot="reference">{{ scope.row.website }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="affiliatewebsite" show-overflow-tooltip label="推广网站">
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <div style="color:#000">{{ scope.row.affiliatewebsite }}</div>
                <span slot="reference">{{ scope.row.affiliatewebsite }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="tags" label="联盟客类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <div style="color:#000">{{ scope.row.tags }}</div>
                <span slot="reference">{{ scope.row.tags }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="platformtype" label="联盟平台"></el-table-column>
          <el-table-column prop="currentaffiliateamount" label="分销金额" sortable="custom">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.currentaffiliateamount).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="amountrate" label="金额占比" sortable="custom"></el-table-column>
          <el-table-column prop="ordercount" label="分销订单数" sortable="custom"></el-table-column>
          <el-table-column prop="orderrate" label="订单数占比" sortable="custom"></el-table-column>
          <el-table-column prop="allcommission" label="佣金金额" sortable="custom">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.totalcommission).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="networkcommission" label="平台费用" sortable="custom">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.networkcommission).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="totalcommission" label="总支出" sortable="custom">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.allcommission).toLocaleString() }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages" v-if="tableData2.length && titlestuts == 2">
        <Pagination :pageNo="formdata.currentPage" :pageSize="formdata.size" :total="total" :continues="4"
          @getPageNo="currentChangeTab2" />
      </div>
      <div class="tablelist ru5 baff" v-if="titlestuts == 3">
        <div style="font-size:14px;margin: 10px 0;" class="font_bo"> 重复订单 数据概览</div>
        <el-table key="shr" :data="tableData3"
          :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }" border
          :span-method="objectSpanMethod">
          <el-table-column prop="orderid" label="订单号"></el-table-column>
          <el-table-column prop="transdate" label="时间"></el-table-column>
          <el-table-column prop="affiliateid" label="联盟客ID"></el-table-column>
          <el-table-column prop="website" show-overflow-tooltip label="推广网站" min-width="150">
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <div style="color:#000">{{ scope.row.website }}</div>
                <span slot="reference">{{ scope.row.website }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="organization" show-overflow-tooltip label="联盟客姓名" min-width="120">
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <div style="color:#000">{{ scope.row.organization }}</div>
                <span slot="reference">{{ scope.row.organization }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="transamount" label="重复订单分销金额">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.transamount).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="tags" label="联盟客类型" show-overflow-tooltip min-width="140">
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <div style="color:#000">{{ scope.row.tags }}</div>
                <span slot="reference">{{ scope.row.tags }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="platformtype" label="联盟平台" width=""></el-table-column>
        </el-table>

      </div>
      <div class="pages" v-if="tableData3.length && titlestuts == 3">
        <Pagination :pageNo="formdatatwo.currentPage" :pageSize="formdatatwo.size" :total="total3" :continues="4"
          @getPageNo="currentChangeTab3" />
      </div>
      <div class="title_top flex" v-if="titlestuts == 3">
        <div class="title flex">
          <div class="title_input">
            <el-input v-model="formdatashr.affliateInfo" placeholder="搜索联盟客姓名/ID/推广网站"></el-input>
            <div class="icons">
              <img src="../../assets/img/foll/search.png" alt="">
            </div>
          </div>
          <div class="title_ks">
            <div class="block">
              <el-date-picker prefix-icon="iconoic" v-model="values" type="daterange" range-separator="至"
                start-placeholder="选择开始日期" end-placeholder="选择结束日期" @change="startDafor">
              </el-date-picker>
              <img src="@/assets/img/emil/rl.png" alt="" />
              <!-- <i class="el-icon-date data_icon"></i> -->
            </div>
          </div>
          <div class="title_scslt">
            <el-select v-model="formdatashr.platformType" clearable placeholder="联盟平台" @clear="delValuefor"
              @change="addvaluefor">
              <el-option v-for="item in hasplist" :key='item.channelType' :label="item.channelTypeValue"
                :value="item.channelTypeValue"></el-option>
            </el-select>
          </div>
        </div>
        <div class="title_qu">
          <div class="title_query ba6e coff center ru5 cursor" @click="searchs2">查询</div>
        </div>
      </div>
      <div class="tablelist ru5 baff" v-if="titlestuts == 3">
        <div style="font-size:14px;margin: 10px 0;" class="font_bo"> 重复订单 联盟客概览</div>
        <div>
          <el-table :data="tableData4" style="width: 100%"
            :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }"
            :default-sort="{ prop: 'date', order: 'descending' }" @sort-change="changeTableSort4">
            <el-table-column prop="affiliateid" label="联盟客ID" width=""></el-table-column>
            <el-table-column prop="organization" show-overflow-tooltip label="联盟客姓名">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <div style="color:#000">{{ scope.row.organization }}</div>
                  <span slot="reference">{{ scope.row.organization }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="website" show-overflow-tooltip label="推广网站">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <div style="color:#000">{{ scope.row.website }}</div>
                  <span slot="reference">{{ scope.row.website }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="ordercount" label="重复订单数" sortable="custom"></el-table-column>
            <el-table-column prop="transamountsum" label="重复订单分销金额" sortable="custom">
              <template slot-scope="scope">
                {{ parseFloat(scope.row.transamountsum).toLocaleString() }}
              </template>
            </el-table-column>
            <el-table-column prop="platformtype" label="联盟平台" width=""></el-table-column>
            <el-table-column prop="tags" show-overflow-tooltip label="联盟客类型">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <div style="color:#000">{{ scope.row.tags }}</div>
                  <span slot="reference">{{ scope.row.tags }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column style="width:120%" prop="" label="订单号" width="180"> e
              <template slot-scope="props">
                <p class="tbas4">{{ props.row.orderids }} </p>
                <p class="oreders" v-if="props.row.orderids.indexOf(',') !== -1">
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      <i v-if="props.row.orderids" class="el-icon-caret-bottom cursor"
                        @click="orderclick(props.row)"></i><i v-if="!props.row.orderids"
                        class="el-icon-caret-top cursor" @click="orderclick(props.row)"></i>
                    </span>
                    <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                      <div class="orderd">
                        <p>{{ props.row.orderids }}</p>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </p>

                <!-- </el-form-item>
                </el-form> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages" v-if="tableData4.length && titlestuts == 3">
        <Pagination :pageNo="formdatashr.currentPage" :pageSize="formdatashr.size" :total="total4" :continues="4"
          @getPageNo="currentChangeTab4" />
      </div>
    </div>
    <!-- <icp></icp> -->
  </div>
</template>
<script>
import { QUERYORDERDETAILLIST, QUERYAFFILIATEDETAILLIST, QUERYREPEATDETAILLIST, QUERYREPEATBDETAILLIST, HASPLATFORMLIST } from '../../api/platform'
import icp from '../icp/icp.vue'
export default {
  components: {
    icp
  },
  data() {
    return {
      oderstuts: 1,
      iconstuts: true,
      iconstuts2: true,
      listStutszs: 1,
      titlestuts: 1,
      tab3tuts: true,
      receiverName: '',
      isClickSearch: false, // 当点击搜索时 对底部分页进行判断
      pagesize: 10,
      values: '',
      valuescf: '',
      values2: '',
      values3: '',
      isRead2: '',
      isRead3: '',
      tableData: [],
      mCTableData: [],
      pt: '',
      ordersum: '',
      validParam: localStorage.getItem('validParam'),
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      total: 0, // 总条数
      total3: 0,
      total4: 0,
      tableDataAnother: [],
      texthonder: '搜索原始订单号',
      orderId: '',
      platformType: '',
      startDate: '',
      endDate: '',
      currentPage: 1, // 当前页码
      size: 10,
      sort: '',
      formdata: {
        affliateInfo: '',
        platformType: '',
        startDate: '',
        endDate: '',
        currentPage: 1, // 当前页码
        size: 10,
        sort: '',
      },
      formdatatwo: {
        orderId: '',
        startDate: '',
        endDate: '',
        currentPage: 1, // 当前页码
        size: 10,
        sort: '',
      },
      formdatashr: {
        affliateInfo: '',
        startDate: '',
        endDate: '',
        currentPage: 1,
        size: 10,
        sort: '',
        platformType: '',
      },
      proptype: '',
      hasplist: [],
    }
  },

  mounted() {
    if (this.validParam !== 'bgxqformal') {
      this.$bus.$emit('showNopermiss',true)
      return
    }
    this.queryOrderDetailListmap()
    this.hasPlatformList()
  },
  methods: {
    hasPlatformList() {
      HASPLATFORMLIST().then(res => {
        if (res.data.body) {
          this.hasplist = res.data.body
        }
      })
    },
    poxs(e) {
      if (e == 1) {
        this.sort = 'transactionDateDesc'
      } else if (e == 2) {
        this.sort = 'transactionDateAsc'
      } else if (e == 3) {
        this.sort = 'transactionAmountDesc'
      } else if (e == 4) {
        this.sort = 'transactionAmountAsc'
      } else if (e == 5) {
        this.sort = 'totalCommissionDesc'
      } else if (e == 6) {
        this.sort = 'totalCommissionAsc'
      } else if (e == 7) {
        this.sort = 'networkCommissionDesc'
      } else if (e == 8) {
        this.sort = 'networkCommissionAsc'
      }
      this.queryOrderDetailListmap()
    },
    queryOrderDetailListmap() {
      let data = {
        orderId: this.orderId,
        platformType: this.platformType,
        startDate: this.startDate,
        endDate: this.endDate,
        currentPage: this.currentPage,
        size: this.size,
        sort: this.sort
      }
      QUERYORDERDETAILLIST(data).then(res => {
        if (res.data.body.records) {
          this.tableData1 = res.data.body.records
          this.total = res.data.body.total
        }

      })
    },
    queryAffiliateDetailListmap() {
      QUERYAFFILIATEDETAILLIST(this.formdata).then(res => {
        if (res.data.body.records) {
          this.tableData2 = res.data.body.records
          this.total = res.data.body.total
        }

      })
    },
    queryRepeatDetailListmap() {
      QUERYREPEATDETAILLIST(this.formdatatwo).then(res => {
        if (res.data.body.records) {
          this.tableData3 = res.data.body.records
          this.total3 = res.data.body.total
        }

      })
    },
    queryRepeatBDetailListmap() {
      QUERYREPEATBDETAILLIST(this.formdatashr).then(res => {
        if (res.data.body.records) {
          this.tableData4 = res.data.body.records
          this.total4 = res.data.body.total
        }
      })
    },

    changeTableSort1(column) {
      this.currentPage = 1
      if (column.order === 'ascending') {
        if (column.prop == 'transactionDate') {
          this.sort = 'transactionDateAsc'
          this.queryOrderDetailListmap()
        } else if (column.prop == 'transactionAmount') {
          this.sort = 'transactionAmountAsc'
          this.queryOrderDetailListmap()
        } else if (column.prop == 'totalCommission') {
          this.sort = 'totalCommissionAsc'
          this.queryOrderDetailListmap()
        } else if (column.prop == 'networkCommission') {
          this.sort = 'networkCommissionAsc'
          this.queryOrderDetailListmap()
        }
      } else if (column.order === 'descending') {
        if (column.prop == 'transactionDate') {
          this.sort = 'transactionDateDesc'
          this.queryOrderDetailListmap()
        } else if (column.prop == 'transactionAmount') {
          this.sort = 'transactionAmountDesc'
          this.queryOrderDetailListmap()
        } else if (column.prop == 'totalCommission') {
          this.sort = 'totalCommissionDesc'
          this.queryOrderDetailListmap()
        } else if (column.prop == 'networkCommission') {
          this.sort = 'networkCommissionDesc'
          this.queryOrderDetailListmap()
        }
      }
    },
    changeTableSort(column) {
      this.formdata.currentPage = 1
      if (column.order === 'ascending') {
        if (column.prop == 'currentaffiliateamount') {
          this.formdata.sort = 'currentAffiliateAmountAsc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'amountrate') {
          this.formdata.sort = 'amountRateAsc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'ordercount') {
          this.formdata.sort = 'orderCountAsc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'orderrate') {
          this.formdata.sort = 'orderRateAsc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'allcommission') {
          this.formdata.sort = 'totalCommissionAsc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'networkcommission') {
          this.formdata.sort = 'networkCommissionAsc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'totalcommission') {
          this.formdata.sort = 'allCommissionAsc'
          this.queryAffiliateDetailListmap()
        }
      } else if (column.order === 'descending') {
        if (column.prop == 'currentaffiliateamount') {
          this.formdata.sort = 'currentAffiliateAmountDesc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'amountrate') {
          this.formdata.sort = 'amountRateDesc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'ordercount') {
          this.formdata.sort = 'orderCountDesc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'orderrate') {
          this.formdata.sort = 'orderRateDesc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'allcommission') {
          this.formdata.sort = 'totalCommissionDesc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'networkcommission') {
          this.formdata.sort = 'networkCommissionDesc'
          this.queryAffiliateDetailListmap()
        } else if (column.prop == 'totalcommission') {
          this.formdata.sort = 'allCommissionDesc'
          this.queryAffiliateDetailListmap()
        }
      }
    },
    changeTableSort4(column) {
      this.tableData4.currentPage = 1
      if (column.order === 'ascending') {
        if (column.prop == 'ordercount') {
          this.formdatashr.sort = 'orderCountAsc'
          this.queryRepeatBDetailListmap()
        } else if (column.prop == 'transamountsum') {
          this.formdatashr.sort = 'transAmountSumAsc'
          this.queryRepeatBDetailListmap()
        }
      } else if (column.order === 'descending') {
        if (column.prop == 'ordercount') {
          this.formdatashr.sort = 'orderCountDesc'
          this.queryRepeatBDetailListmap()
        } else if (column.prop == 'transamountsum') {
          this.formdatashr.sort = 'transAmountSumDesc'
          this.queryRepeatBDetailListmap()
        }
      }
    },
    // 升序排列方法
    ascSortFun(a, b) {
      return a[this.proptype] - b[this.proptype]
    },
    // 降序排列方法
    desSortFun(a, b) {
      return b[this.proptype] - a[this.proptype]
    },
    renderHeader(e) {
    },
    iconclick(e) {
      if (e == 1) {
        this.iconstuts = !this.iconstuts
      } else {
        this.iconstuts2 = !this.iconstuts2
      }

    },
    tits(e) {
      this.titlestuts = e
      this.receiverName = ''
      if (e == 1) {
        this.queryOrderDetailListmap()
      } else if (e == 2) {
        this.queryAffiliateDetailListmap()
      } else if (e == 3) {
        this.queryRepeatDetailListmap()
        this.queryRepeatBDetailListmap()
      }
    },
    formatter(row, column) {
      return row.address;
    },
    // 日期选择事件
    startDa(e) {
      if (e == null) {
        this.startDate = ''
        this.endDate = ''
      } else {
        this.startDate = e[0].getFullYear() + '-' + (e[0].getMonth() + 1) + '-' + e[0].getDate();
        this.endDate = e[1].getFullYear() + '-' + (e[1].getMonth() + 1) + '-' + e[1].getDate();
      }
    },
    startDatwo(e) {
      if (e == null) {
        this.formdata.startDate = ''
        this.formdata.endDate = ''
      } else {
        this.formdata.startDate = e[0].getFullYear() + '-' + (e[0].getMonth() + 1) + '-' + e[0].getDate();
        this.formdata.endDate = e[1].getFullYear() + '-' + (e[1].getMonth() + 1) + '-' + e[1].getDate();
      }
    },
    startDashr(e) {
      if (e == null) {
        this.formdatatwo.startDate = ''
        this.formdatatwo.endDate = ''
      } else {
        this.formdatatwo.startDate = e[0].getFullYear() + '-' + (e[0].getMonth() + 1) + '-' + e[0].getDate();
        this.formdatatwo.endDate = e[1].getFullYear() + '-' + (e[1].getMonth() + 1) + '-' + e[1].getDate();
      }
    },
    startDafor(e) {
      if (e == null) {
        this.formdatashr.startDate = ''
        this.formdatashr.endDate = ''
      } else {
        this.formdatashr.startDate = e[0].getFullYear() + '-' + (e[0].getMonth() + 1) + '-' + e[0].getDate();
        this.formdatashr.endDate = e[1].getFullYear() + '-' + (e[1].getMonth() + 1) + '-' + e[1].getDate();
      }
    },
    delValue() {
      this.platformType = ''
    },
    addvalue(e) {
      this.platformType = e
    },

    delValuetwo() {
      this.formdata.platformType = ''
    },
    addvaluetwo(e) {
      this.formdata.platformType = e
    },
    delValueshr() {
      this.formdatatwo.platformType = ''
    },
    delValuefor() {
      this.formdatashr.platformType = ''
      this.isRead3 = ''
    },
    addvaluefor(e) {
      this.formdatashr.platformType = e
    },
    searchs1() {
      this.formdatatwo.currentPage = 1
      this.formdata.currentPage = 1
      this.currentPage = 1
      if (this.titlestuts == 1) {
        this.queryOrderDetailListmap()
      } else if (this.titlestuts == 2) {
        this.queryAffiliateDetailListmap()
      } else if (this.titlestuts == 3) {
        this.queryRepeatDetailListmap()
      }
    },
    searchs2() {
      this.formdatashr.currentPage = 1
      this.queryRepeatBDetailListmap()
    },
    searchs() {

    },
    //
    currentChangeTwo(val) {
      this.currentPage = val.page
      this.size = val.limit
      this.queryOrderDetailListmap()
    },
    getPageNo(pageNo) {
      this.currentPage = pageNo
      this.queryOrderDetailListmap()
    },
    currentChangeTab2(val) {
      this.formdata.currentPage = val
      this.queryAffiliateDetailListmap()
    },
    currentChangeTab3(val) {
      this.formdatatwo.currentPage = val
      this.queryRepeatDetailListmap()
    },
    currentChangeTab4(val) {
      this.formdatashr.currentPage = val
      this.queryRepeatBDetailListmap()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    orderclick(e) {
      e.choose = !e.choose;
    }
  }
}
</script>
<style lang="less" scoped>
.tbas4 {
  width: 90%;
  white-space: nowrap;
  /*内容超宽后禁止换行显示*/

  overflow: hidden;
  /*超出部分隐藏*/

  text-overflow: ellipsis;
  /*文字超出部分以省略号显示*/
}

.tab_p {
  word-wrap: break-word;
  word-break: break-all;
}

.pages {
  margin: 30px 0 50px 0;
}

.listba {
  // background:#a6a8bf;
  background: rgba(166, 168, 191, 0.25) !important;
}

.nologins {
  width: 120px;
  border-radius: 14px;

  .nologins_title {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(64, 64, 64, 0.25);
    padding-left: 7px;
  }

  .nologins_list {
    width: 100%;
    height: 32px;
    line-height: 32px;
    margin: 10px 0;
  }
}

.report {
  width: 100%;
  height: 100%;
  padding-left: 20Px;
  padding-top: 69px;
  background: #fafafd;
  box-sizing: border-box;

  .top {
    width: 100%;
    height: 84px;
    border-bottom: 2px solid rgba(166, 168, 191, 0.25);
    align-items: center;
    position: relative;
    margin-bottom: 24px;
    justify-content: space-between;

    .top_left {
      align-items: center;
      height: 100%;

      div {
        margin-right: 60px;
        padding-bottom: 10px;
      }

      .top_left_list {
        color: #be3c6e;
        border-bottom: 2px solid #be3c6e;
      }
    }

    .top1 {
      width: 30%;
      height: 84px;
      align-items: center;
      position: absolute;
      right: 0;

      .top_center1 {
        width: 300px;
        position: absolute;
        right: 0;

        .top_center_one {
          width: 40%;
          margin-right: 20%;
          border-bottom: 1px solid;

          .scect {
            width: 120px;
            position: relative;
            align-items: center;
            padding-bottom: 3px;
            margin-top: 5px;

            i {
              position: absolute;

              right: 0;
            }
          }
        }

        .top_center_two {
          width: 40%;
          border-bottom: 1px solid;

          .scect {
            width: 120px;
            position: relative;
            align-items: center;
            padding-bottom: 3px;
            margin-top: 5px;

            i {
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }
  }

  .top_right {
    width: 300px;

    .top_center_one {
      width: 40%;
      margin-right: 20%;

      .scect {
        border-bottom: 1px solid;
        position: relative;

        i {
          position: absolute;
          right: 0;
        }
      }
    }

    .top_center_two {
      width: 40%;

      .scect {
        border-bottom: 1px solid;
        position: relative;

        i {
          position: absolute;
          right: 0;
        }
      }
    }
  }

  .title_top {
    margin-bottom: 15px;

    .title {
      height: 56px;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
      background: #fff;

      div {
        height: 100%;
      }

      .title_input {
        width: 300px;
        height: 54px;
        border-right: 1px solid #d5d5d5;
        position: relative;

        .icons {
          width: 16px;
          height: 56px;
          position: absolute;
          right: 10px;
          top: 0;
          display: flex;
          align-items: center;

          img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .title_ks {
        width: 500px;
        border-right: 1px solid #d5d5d5;
        position: relative;

        img {
          width: 34px;
          height: 30px;
          position: absolute;
          left: 30px;
          top: 50%;
          margin-top: -15px;
        }
      }

      .title_scslt {
        width: 284px;
      }
    }

    .title_qu {
      height: 56px;
      display: flex;
      align-items: center;
      padding-left: 24px;

      .title_query {
        width: 130px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
      }
    }
  }

  .tablelist {
    width: 100%;
    padding: 10px;

    .tablelist_title {
      padding: 0 10px;
      background: rgba(167, 169, 192, 0.25);

      .tablelist_title_list {
        height: 40px;
        align-items: center;
      }
    }
  }

  .tab3 {
    display: flex;

    p {
      min-width: 60px;
    }

    span {
      display: inline-block;
      width: 50px;
      text-align: center;
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

.top_center {
  height: 100vh;
}

.orderd {
  width: 241px;
  height: 112px;
  padding: 0 10px;
  overflow: auto;
  word-break: break-all;
  font-size: 14px;

  p {
    display: inline-block;
    line-height: 30px;
  }
}

.orderd::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #a6a8bf;
}

.orderd::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

.orderd::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
</style>
<style lang="less">
.report {
  .title_input .el-input__inner {
    height: 100%;
    border: none;
  }

  .el-select .el-input__inner {
    border: none;
  }

  // .el-select > .el-input{
  //   display: none;
  // }
  .el-pagination__sizes {
    display: none !important;
  }

  .el-pagination__total {
    display: none !important;
  }

  .el-input--suffix .el-input__inner {
    height: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-select>.el-input {
    width: 100%;
    height: 100%;
  }

  .el-pager li.active {
    // color: #be3c6e;
    color: #000;
    font-family: "OPPOSans-R";
    src: url("../../assets/ttf/OPPOSans-R.ttf");
  }

  .el-pagination__total {
    display: none !important;
  }

  .el-pagination__sizes {
    display: none !important;
  }

  .btn-next {
    min-width: 52px !important;
    height: 22px !important;
    font-size: 12px !important;
    text-align: center !important;
    line-height: 22px !important;
    background: rgba(168, 168, 191, 0.25) !important;
    border-radius: 6px 6px 6px 6px !important;
    padding-right: 9.6px;
  }

  .btn-prev {
    min-width: 52px !important;
    height: 22px !important;
    font-size: 12px !important;
    text-align: center !important;
    line-height: 22px !important;
    background: #e5e6ee !important;
    background: rgba(168, 168, 191, 0.25) !important;
    padding: none !important;
    padding-left: 5px !important;
    padding-left: 9.6px !important;
  }

  .el-pager {
    margin: 0 15px;
    background: #fafafd;
  }

  .el-pager li.active {
    background: #e5e6ee;
    color: #000;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    margin: 0 5px;
  }

  .el-pager li {
    background: none;
    height: 22px;
    line-height: 22px;
    font-weight: 400;
    margin: 0 5px;
  }

  .el-pagination {
    text-align: right !important;
  }

  .pagination-container {
    padding: none !important;
  }

  .el-pagination .btn-next {
    padding-right: 12px;
  }

  .el-pagination button:disabled {
    border-radius: 5px;
  }

  .el-pagination .btn-prev {
    border-radius: 5px;
  }

  .el-pagination button:hover {
    color: #303133;
  }

  .el-pager li:hover {
    color: #303133;
  }

  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    line-height: 22px;
  }

  .el-range-editor.el-input__inner {
    width: 100%;
    border: none;
    padding-left: 50px;
  }

  .el-date-editor .el-range-separator {
    height: 100%;
    line-height: 48px;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background: #be3c6e;
  }

  .el-drawer__wrapper {
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }

  // .pagination-container{
  //   ba
  // }

  // .el-icon-arrow-up:before {
  //   content: "";
  // }
  .cent_input {
    .el-input--suffix .el-input__inner {
      padding-left: 30px;
    }
  }

  .el-icon-arrow-right:before {
    content: "\";
    color: #000;
    font-size: 16px;
  }
}

.bulletinBoard {
  padding-left: 20Px;
  .el-dropdown {
    width: 100%;
  }
}

.el-dropdown-menu__item {
  padding: 0 !important;
  color: #000;
}

.bulletinBoard.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #000;
  background: none;
}

.el-table th.el-table__cell>.cell {
  font-weight: 400;
}

.el-icon-arrow-up:before {
  content: "";
}

.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #be3c6e;
}

.el-table .descending .sort-caret.descending {
  border-top-color: #be3c6e;
}

.el-table td.el-table__cell div {
  position: relative;

  .oreders {
    width: 16px;
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 10px;
    color: #be3c6e;
    display: flex;
    align-content: center;
  }

  .el-popper[x-placement^="bottom"] {
    width: 240px !important;
  }
}

.el-tooltip__popper.is-dark {
  display: none !important;
}
</style>